import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/toaster";
import Home from "@/pages/Home";
import { Frameworks, FrameworkDetail } from "@/pages/Frameworks";
import { AustraliaHub, RegulatorDetail } from "@/pages/Australia";
import MoneyFlow from "@/pages/MoneyFlow";
import { Tools, CarsCalculator } from "@/pages/Tools";
import Glossary from "@/pages/Glossary";
import { Insights, InsightDetail } from "@/pages/Insights";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Advisor from "@/pages/Advisor";
import Admin from "@/pages/Admin";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/frameworks" element={<Frameworks />} />
          <Route path="/frameworks/:slug" element={<FrameworkDetail />} />
          <Route path="/australia" element={<AustraliaHub />} />
          <Route path="/australia/:slug" element={<RegulatorDetail />} />
          <Route path="/money-flow" element={<MoneyFlow />} />
          <Route path="/tools" element={<Tools />} />
          <Route path="/tools/cars-calculator" element={<CarsCalculator />} />
          <Route path="/glossary" element={<Glossary />} />
          <Route path="/insights" element={<Insights />} />
          <Route path="/insights/:slug" element={<InsightDetail />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/advisor" element={<Advisor />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
